import { BaseService } from '@core/base/service/base-service'
import { TGetCasesPageResult, TPagination } from '@core/modules/mdr/mdr'
import { GetCasesResponseData_Output } from '@atbay/salesforce-mdr-gateway-node-sdk/lib/types/models/GetCasesResponseData_Output'
import { transformGetCasesResponseData } from '@core/utils/salesforce-mdr-gateway/salesforce-mdr-gateway-utils'

export const SalesforceMdrGatewayService =
    new (class SalesforceMdrGatewayService extends BaseService {
        constructor() {
            super('salesforce.mdr.service')
        }

        async getAccountCases(
            fetchMock = false,
            page = 1
        ): Promise<TGetCasesPageResult | null> {
            const fetch = fetchMock
                ? () =>
                      this.request(() =>
                          this.http.get(
                              `/api/accounts/${this.accountId}/cases/mock`
                          )
                      )
                : () =>
                      this.request(() =>
                          this.http.get(
                              `/api/accounts/${this.accountId}/cases`,
                              { params: { page } }
                          )
                      )

            const [error, result] = await fetch()

            if (error) {
                console.error(
                    `[getAccountCases] Error fetching cases for accountId: ${this.accountId}`,
                    error
                )
                return null
            }

            const data = result?.data?.data as
                | GetCasesResponseData_Output
                | undefined
            if (!data) {
                console.error(
                    `[getAccountCases] No data returned for accountId: ${this.accountId}`
                )
                return null
            }

            const pagination =
                (result?.data?.pagination as TPagination | undefined) ?? null

            return {
                data: transformGetCasesResponseData(data),
                pagination,
            }
        }
    })()
